import { Component } from '@angular/core';


export class SkyTileDemoTile2Component { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  // tslint:disable-next-line
  selector: 'div.tile2',
  template: `<sky-tile>
  <sky-tile-title>
    Tile 2
  </sky-tile-title>
  <sky-tile-content>
    <sky-tile-content-section>
      Section 1
    </sky-tile-content-section>
    <sky-tile-content-section>
      Section 2
    </sky-tile-content-section>
    <sky-tile-content-section>
      Section 3
    </sky-tile-content-section>
  </sky-tile-content>
</sky-tile>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
